module.exports = __webpack_public_path__ + "resources/img/img_spiceware_pii_anp_02_en.dc9995022e045a59a073986312c5d659.png";